import { render, staticRenderFns } from "./OrganizationAddressRow.vue?vue&type=template&id=22f09988&"
import script from "./OrganizationAddressRow.vue?vue&type=script&lang=js&"
export * from "./OrganizationAddressRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports